import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomToneOfVoice,
  BackendMutationExtractCustomToneOfVoiceFromEditorArgs,
} from 'src/types/backend';

import { FRAGMENT_CUSTOM_TONE_OF_VOICE } from './schema';

const MUTATION = gql`
  mutation ExtractCustomToneOfVoiceFromEditor(
    $customerId: ID!
    $brandVoiceId: ID!
    $url: String
    $text: String
    $resourceId: ID
    $inputType: TovExtractionInputTypeEnum
    $language: String
  ) {
    extractCustomToneOfVoiceFromEditor(
      customerId: $customerId
      brandVoiceId: $brandVoiceId
      url: $url
      text: $text
      resourceId: $resourceId
      inputType: $inputType
      language: $language
    ) {
      ...CustomToneOfVoice
    }
  }
  ${FRAGMENT_CUSTOM_TONE_OF_VOICE}
`;

type Variables = BackendMutationExtractCustomToneOfVoiceFromEditorArgs;
type Result = BackendCustomToneOfVoice;

export const extractCustomToneOfVoiceFromEditor = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
